import { render, staticRenderFns } from "./quick-order-cancel.vue?vue&type=template&id=233a1c84&scoped=true&"
import script from "./quick-order-cancel.vue?vue&type=script&lang=js&"
export * from "./quick-order-cancel.vue?vue&type=script&lang=js&"
import style0 from "./quick-order-cancel.vue?vue&type=style&index=0&id=233a1c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a1c84",
  null
  
)

export default component.exports